import { render, staticRenderFns } from "./author-view-works-item.vue?vue&type=template&id=3684ce67&scoped=true&"
import script from "./author-view-works-item.vue?vue&type=script&lang=js&"
export * from "./author-view-works-item.vue?vue&type=script&lang=js&"
import style0 from "./author-view-works-item.vue?vue&type=style&index=0&id=3684ce67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3684ce67",
  null
  
)

export default component.exports